export default {
  create: 'Utwórz zadanie konserwacyjne',
  edit: 'Edytuj zadanie konserwacyjne',
  taskName: 'Nazwa zadania',
};
